import classNames from 'clsx';
import { ReactComponent as IconClose } from 'img/icons/close.svg';
import React, { memo } from 'react';
import { Hint } from 'reactApp/ui/Hint/Hint';
import { Circle } from 'reactApp/ui/UploadList/Item/Circle';

import styles from './LoaderIcon.css';

interface ILoaderProps {
    progress?: number;
    className?: string;
}

interface IProps {
    progress?: number;
    loading?: boolean;
    iconHover?: boolean;
}

const stroke = 2;
const radius = 15;
const iconCloseSize = 14;

const Loader = memo(({ progress = 0, className }: ILoaderProps) => (
    <Circle radius={radius} stroke={stroke} progress={progress} className={className} />
));

export const LoaderIcon = memo(({ progress, loading, iconHover = false }: IProps) => (
    <div className={styles.loading}>
        {loading && <Loader progress={progress} className={styles.loader} />}
        <Hint text="Отменить загрузку">
            <IconClose width={iconCloseSize} height={iconCloseSize} className={styles.loadingClose} />
        </Hint>
        <Loader progress={100} className={classNames({ [styles.loaderDefault]: true, [styles.loaderDefaultHover]: iconHover })} />
    </div>
));
